<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-i-knowing-your-self-begins-by-knowing-your-cells">
<h1 style="margin-top:250px;font-family:Arial;">Part I <br/>Knowing Your Self Begins by<br/> Knowing Your Cells</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?0291b2a4